import * as React from 'react';
import styled from 'styled-components';
import { getBaseURL } from '../../../config/runtime';
import { Customer } from '../../../domain/customer/Customer';
import { fireToast } from '../../../event/toastEvent';
import { fireCustomerAddedEvent } from '../../../event/customerAddedEvent';
import { postResolveJSON } from '../../../util/fetch';
import { COLOR_INVALID } from '../../constants';
import Input, { InputGroup } from '../input/Input';
import { Label } from '../input/Label';
import IconAdd from '../../icon/IconAdd';
import Spinner from '../../Spinner';
import Button from '../button/Button';
import fireCustomerOpenEvent from '../../../event/customerOpenEvent';

const Content = styled.section`
  background: #fff;
  padding: 1rem 1.4rem;
`;

const IconPanel = styled.div`
  display: inline-block;
  height: 1.2rem;
  position: relative;
  vertical-align: middle;
  width: 1.2rem;
`;

const MarginLabel = styled(Label)`
  font-size: 0.95rem;
  margin-top: 1rem;
`;

const In = styled(Input)`
  margin-bottom: 1rem;
`;

const InMandatory = styled(Input)<{ invalid: boolean }>`
  border-color: ${(props) => (props.invalid ? COLOR_INVALID : '')};
  border-left-color: ${COLOR_INVALID};
  border-left-width: 0.2rem;
`;

const InvalidMessage = styled.label`
  color: ${COLOR_INVALID};
  display: block;
  font-size: 0.9rem;
  margin-top: 0.2rem;
`;

const ButtonLabel = styled.label`
  display: inline-block;
  font-weight: bold;
  padding: 0.2rem 0.4rem;
  vertical-align: middle;
`;

const SendInvitePanel = styled.div`
  padding: 1rem 0;
`;

const SendInviteCheckbox = styled.input`
  margin-right: 0.5rem;
  transform: scale(1.1);
  vertical-align: middle;

  :hover {
    cursor: pointer;
  }
`;

const SendInviteLabel = styled.label`
  letter-spacing: 0.05rem;
  vertical-align: middle;

  :hover {
    cursor: pointer;
  }
`;

const buttonStyles = `
  display: inline-block;
  margin-top: 1rem;
  padding: .3rem .5rem;
`;

const Add = () => {
  const [customerID, setCustomerID] = React.useState('');
  const [firstname, setFirstname] = React.useState('');
  const [lastname, setLirstname] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [sendInvite, setSendInvite] = React.useState(false);
  // const [emailInvalid, setEmailInvalid] = React.useState(false);
  // const [firstnameInvalid, setFirstnameInvalid] = React.useState(false);
  const [customerIDInvalid, setCustomerIDInvalid] = React.useState(false);

  const showLoading = () => setLoading(true);

  const hideLoading = () => setLoading(false);

  const addCustomer = async () => {
    // @ts-ignore
    const customer: Customer = {
      customer_id: customerID,
      name_first: firstname,
      name_last: lastname,
      email,
    };

    // const validEmail = validateEmail();
    // const validFirstname = validateFirstname();
    // setEmailInvalid(!validEmail);
    // setFirstnameInvalid(!validFirstname);

    const validCustomerID = validateCustomerID();
    setCustomerIDInvalid(!validCustomerID);

    // if (validEmail && validFirstname) {
    if (validCustomerID) {
      showLoading();

      try {
        const resp = await postResolveJSON<Customer & { object: string }>(`${getBaseURL()}/v1/cmd/customers`, customer);
        hideLoading();

        if (resp.object === 'customer') {
          fireToast(`Customer ${customer.customer_id} has been added.`);
          fireCustomerAddedEvent(resp);
          fireCustomerOpenEvent(resp); // GWT hooks into this.
        } else {
          fireToast(`There was a problem creating customer with ID ${customer.customer_id}`);
        }
      } catch (error) {
        /**
         * Don't put hideLoading in finally as this will result in a warning as
         * fireCustomerAddedEvent will close the popup if call to add customer
         * end-point is successful.
         */
        hideLoading();
        fireToast(`There was a problem creating customer with ID ${customer.customer_id}`);
      }
    }
  };

  const validateCustomerID = () => customerID.length > 0;

  // const validateEmail = () => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);

  // const validateFirstname = () => firstname.length > 0;

  const onCustomerIDChange = (e: React.ChangeEvent<HTMLInputElement>) => setCustomerID(e.target.value);

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value);

  const onFirstnameChange = (e: React.ChangeEvent<HTMLInputElement>) => setFirstname(e.target.value);

  const onLastnameChange = (e: React.ChangeEvent<HTMLInputElement>) => setLirstname(e.target.value);

  return (
    <Content>
      <MarginLabel>Customer ID</MarginLabel>

      <InputGroup>
        <InMandatory
          disabled={loading}
          invalid={customerIDInvalid}
          maxLength={50}
          onChange={onCustomerIDChange}
        />
        {customerIDInvalid ? (
          <InvalidMessage>Please enter a customer ID.</InvalidMessage>
        ) : null}
      </InputGroup>

      <Label>Email</Label>
      <In
        disabled={loading}
        // invalid={emailInvalid}
        maxLength={50}
        onChange={onEmailChange}
      />
      {/* {emailInvalid ? (
        <InvalidMessage>Please enter a valid email address</InvalidMessage>
      ) : null} */}

      <Label>First Name</Label>
      <In
        disabled={loading}
        // invalid={firstnameInvalid}
        maxLength={50}
        onChange={onFirstnameChange}
      />
      {/* {firstnameInvalid ? (
        <InvalidMessage>Please enter a first name</InvalidMessage>
      ) : null} */}

      <Label>Last Name</Label>
      <In
        disabled={loading}
        // invalid={lastnameInvalid}
        maxLength={50}
        onChange={onLastnameChange}
      />

      {/* <SendInvitePanel>
        <SendInviteCheckbox
          disabled={loading}
          type="checkbox"
          name="send invite"
          onChange={() => setSendInvite(!sendInvite)}
          checked={sendInvite}
        ></SendInviteCheckbox>
        <SendInviteLabel onClick={() => setSendInvite(!sendInvite)}>
          Invite customer
        </SendInviteLabel>
      </SendInvitePanel> */}

      <Button onClick={addCustomer} styles={buttonStyles}>
        <table>
          <tbody>
            <tr>
              <td>
                <IconPanel>{loading ? <Spinner /> : <IconAdd style={{ height: '100%', width: '100%', fill: '#fff' }} />}</IconPanel>
              </td>

              <td>
                <ButtonLabel>Add Customer</ButtonLabel>
              </td>
            </tr>
          </tbody>
        </table>
      </Button>
    </Content>
  );
};

export default Add;
